<template>
  <onboarding-identity-step-layout>
    <template v-slot:content>
      <asset-v3
        class="step--icon"
        dir="abstract"
        name="onboarding-selfie.svg"
      />

      <h3 class="gray-900 mb-16">Envio da selfie</h3>
      <ul class="selfie--instructions">
        <li>
          Procure um ambiente bem iluminado
        </li>
        <li>
          Retire boné, óculos ou qualquer acessório que esteja utilizando
        </li>
      </ul>
    </template>

    <template v-slot:footer>
      <round-button
        color="primary mt-12"
        @click="goToSelfieCamera"
        content="Continuar"
      />
      <security-warning class="hide-on-large mt-12 pb-12" />
      <security-warning class="only-on-large mt-12 pb-32" />
    </template>
  </onboarding-identity-step-layout>
</template>

<script>
import { mapState } from 'vuex';
import AssetV3 from '@/components/common/AssetV3.vue';
import RoundButton from '../../paymentLink/components/RoundButton.vue';
import OnboardingIdentityStepLayout from '../components/OnboardingIdentityStepLayout.vue';
import SecurityWarning from '../../paymentLink/components/SecurityWarning.vue';

export default {
  name: 'v2-onboarding-selfie',
  components: {
    AssetV3,
    RoundButton,
    OnboardingIdentityStepLayout,
    SecurityWarning,
  },
  computed: {
    ...mapState('onboardingV2', ['selfieFlow']),
  },
  methods: {
    async goToSelfieCamera() {
      const selfieCameraRouteName = this.selfieFlow === 'FACETEC'
        ? 'v2-onboarding-selfie-camera-facetec'
        : 'v2-onboarding-selfie-camera-parcelex';

      await this.$router.replace({
        name: selfieCameraRouteName,
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" style="scoped">
  @import '../../../scss/__new-styles.scss';

  .onboarding--container__selfie {
    padding: 0px 24px 0 24px;
    display: grid;
    grid-template-rows: 150px 3fr 80px;
    grid-template-columns: 1fr;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    min-height: 100vh;
  }

  .onboarding--header {
    .prclx-logo {
      display: flex;
      padding-top: 16px;
      justify-content: center;
    }

    .step--bar {
      padding-top: 24px;
    }
  }

  .onboarding--content {
    .step--icon {
      margin-bottom: 12px;
    }
  }

  .selfie--instructions {
    @extend .body-regular;
    @extend .gray-900;
    list-style: disc;
    padding: 0px 0px 0px 24px;
  }
</style>
